import { CheckCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import { Modal } from 'antd';
import React from 'react';
import { getPid, getProductId } from '@/infrastructure/product-info';

interface PropsType {
  showCopyMessage: () => void;
  submitResult: string;
  submitDialogVisible: boolean;
  setSubmitDialogVisible: (value: boolean) => void;
}

export const SubmitResult = (props: PropsType) => {
  const {
    showCopyMessage,
    submitResult,
    submitDialogVisible,
    setSubmitDialogVisible,
  } = props;

  const renderCopyText = () => (
    <a
      id="copyBtn"
      data-clipboard-text={`${window.location.protocol}//${window.location.host}/v2/setting/members?productId=${getProductId()}&pid=${getPid()}${submitResult === 'succ' ? '&tabIndex=1' : ''}`}
      style={{ color: '#0062FF' }}
      onClick={showCopyMessage}
    >复制链接</a>
  );

  return <>
    <Modal
      footer={null}
      title={submitResult === 'succ'
        ? <span><CheckCircleFilled style={{ color: '#3DD598', marginRight: '5px' }} />申请提交成功</span>
        : <span><ExclamationCircleFilled style={{ color: '#FC5A5A', marginRight: '5px' }} />申请提交失败</span>}
      visible={submitDialogVisible}
      onCancel={() => setSubmitDialogVisible(false)}
    >
      {submitResult === 'succ'
        ? <span>已向管理员发送审核通知，可复制链接发送管理员审批，
            {renderCopyText()}，如遇紧急情况，联系审批人。
          </span>
        : <span>申请发送失败，可复制链接发送管理员手动添加，
            {renderCopyText()}。
          </span>}
    </Modal>
  </>;
};
